module.exports = __webpack_public_path__ + "exo-latin-800.855ca29bb887be8df4bb.svg";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-800.svg
// module id = ../../../../typeface-exo/files/exo-latin-800.svg
// module chunks = styles